







































































































import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator'
import {
  IcoachSkillShortInfo,
  SurveyInfo,
  TsManagerUser,
  TsRateeUser,
  TsUserDto,
  TsUserRole
} from '@/interfaces'
import {
  Getter
} from 'vuex-class'
import RaterRateeCard from '@/components/360/RaterRateeCard.vue'
import TsService from '@/services/TsService'
import RaterRateeSkillCard from '@/components/360/RaterRateeSkillCard.vue'
import PerformanceManagerCard from '@/components/360/PerformanceManagerCard.vue'
import AppFooter from '@/components/footer/AppFooter.vue'

  @Component({
    name: 'RaterRateePage',
    components: {
      RaterRateeCard,
      PerformanceManagerCard,
      RaterRateeSkillCard,
      AppFooter
    }
  })
export default class RaterRateePage extends Vue {
    @Prop()
    tsSurveyId!: number;

    @Prop()
    tsRaterRateeId!: number;

    @Getter('user/isAuthenticated')
    isAuthenticated!: boolean;

    @Getter('survey/getDisplayedBaseSurveyInfo')
    surveyInfo!: SurveyInfo;

    @Getter('ts/hasRoleRatee')
    hasRoleRatee!: boolean;

    @Getter('ts/hasRoleRater')
    hasRoleRater!: boolean

    @Getter('ts/hasRoleManager')
    hasRoleManager!: boolean;

    @Getter('ts/getUsers')
    tsUserInfo!: TsUserDto;
    isMobile: boolean = window.innerWidth < 767;
    ratee: TsRateeUser | null = null;
    skillList: IcoachSkillShortInfo[] | null = null;
    groupedSkillList: {
      [key: number]: IcoachSkillShortInfo[]
    } = {};
    myPerformanceManager: TsManagerUser | null = null;
    rateeMobileNav: boolean = false;
    goals: any[] = [
      {
        id: 1,
        title: 'Develop Asian FINTEC Network Capability'
      },
      {
        id: 2,
        title: 'Goal 2'
      },
      {
        id: 3,
        title: 'Goal 3'
      }
    ]

    async toggleRateeMobileNav () {
      this.rateeMobileNav = !this.rateeMobileNav
    }

    async created () {
      if (!this.isAuthenticated) {
        await this.$router.push({
          name: 'notFound'
        })
      }

      if (!this.ratee) {
        this.ratee = await TsService.getRateeInfoById(this.tsRaterRateeId)
      }

      if (!this.skillList) {
        this.skillList = this.hasRoleManager
          ? await TsService.getSkillList(this.tsRaterRateeId)
          : await TsService.getSkillListForUser(this.tsRaterRateeId)
      }

      if (!this.skillList) {
        return
      }

      await this.uploadMyPerformanceManager()
      this.groupedSkillList = this.groupSkills(this.skillList)
    }

    groupSkills (
      skills: IcoachSkillShortInfo[]
    ): {
      [key: number]: IcoachSkillShortInfo[]
    } {
      return skills.reduce((rv: any, skill: IcoachSkillShortInfo) => {
        (rv[skill.category] = rv[skill.category] || []).push(skill)
        return rv
      }, {})
    }

    goToList (): void {
      this.$router.push({
        name: 'survey.ts.dashboard',
        params: {
          tsSurveyId: this.tsSurveyId.toString()
        }
      })
    }

    rateSkill (skill: IcoachSkillShortInfo) {
      this.$router.push({
        name: 'survey.ts.user.ratee.skill',
        params: {
          tsSurveyId: this.tsSurveyId.toString(),
          tsRaterRateeId: this.tsRaterRateeId.toString(),
          skillId: skill.id.toString()
        }
      })
    }

    rateeGoal (goalId: number) {
      this.$router.push({
        name: 'survey.ts.user.ratee.goal',
        params: {
          tsSurveyId: this.tsSurveyId.toString(),
          tsRaterRateeId: this.tsRaterRateeId.toString(),
          goalId: goalId.toString()
        }
      })
    }

    async uploadMyPerformanceManager () {
      if (this.hasRoleRatee) {
        const currentRatee = this.tsUserInfo.users.find(
          user => user.role === TsUserRole.RATEE
        )
        if (!currentRatee) {
          return
        }
        this.myPerformanceManager = await TsService.getManagerInfo(TsUserRole.RATEE, currentRatee.id)
      } else if (this.hasRoleRater) {
        if (!this.ratee) {
          return
        }

        this.myPerformanceManager = await TsService.getManagerInfo(TsUserRole.RATER, this.ratee.id)
      }
    }
}
